<script>
  import { createEventDispatcher } from 'svelte';

  import Icon from '../../common/components/Icon.svelte';

  export let product;
  export let showCompare = true;
  export let productCode;
  export let isWishlisted = false;
  export let isComparedChecked;

  const dispatch = createEventDispatcher();

  let toggleWish = false;
  const onClickWishlist = event => {
    toggleWish = !toggleWish;
    dispatch('changeWishList', {
      toggleWish: toggleWish,
      event: event,
      productCode: productCode,
    });
  };
  const onCompareClick = event => {
    dispatch('toggleCompare', { event, productCode });
    if (sessionStorage.getItem('previous-cat-code') !== sessionStorage.getItem('current-cat-code')) {
      sessionStorage.setItem('previous-cat-code', sessionStorage.getItem('current-cat-code'));
    }
  };
</script>

<div style:--min-height-desktop="24px" style:--min-height-mobile="16px" class="tile-icons-container">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="btn-container fav-icon {isWishlisted ? 'active' : ''}" on:click={event => onClickWishlist(event)}>
    {#if isWishlisted}
      <Icon glyph="heart_filled" mobileSize={20} desktopSize={24} type="font" />
    {:else}
      <span class="fav-wrapper">
        <Icon glyph="heart" mobileSize={20} desktopSize={24} type="font" />
      </span>
    {/if}
  </div>
  {#if showCompare}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="btn-container" on:click={event => onCompareClick(event)}>
      {#if isComparedChecked}
        <span class="c_icon_new c_icon_new--check"></span>
      {:else}
        <Icon glyph="compare" mobileSize={20} desktopSize={24} type="font" />
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  @import '../../../common/styles/vars.scss';
  @import '../../common/styles/colors.new.scss';
  .tile-icons-container {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;

    .btn-container {
      font-weight: 500;
      font-size: 14px;
      color: $icon-only-icon-blue;
      display: flex;
      gap: 2px;
      align-items: center;
      cursor: pointer;
      @include desktop-min-width {
        font-size: 16px;
        gap: 4px;
      }
      .c_icon_new {
        color: $functional-green-01;
        font-size: 2rem;
      }
      strong {
        color: $functional-green-01;
        font-weight: 500;
      }

      .fav-icon {
        &.active {
          border: 1px solid $icon-only-icon-blue;
        }
      }
    }
  }
</style>
